import axios from 'axios';
import store from '../store/store'

export default {
    async execute (method, resource, data) {
        await store.getters.getPropertyGuid
        await store.getters.getTenantGuid
        await store.getters.getJwtAuthenticationToken
        return axios({
            method,
            data,
            headers: {
                Authorization: store.getters.getJwtAuthenticationToken //the token is a variable which holds the token
            },
            url: "/residents/properties/"+store.getters.getPropertyGuid+"/units/users" + resource,
        }).then(async req => {
            return req.data
        })
    },
    updateIdentityPassphrase(userId, userName, passphrase) {
        let userModel = {
            userId: userId,
            userName: userName,
            passphrase: passphrase
        }
        return this.execute('put', '/' + userId, userModel)
    },
    updateIdentityEmail(userId, userName, email) {
        let userModel = {
            userId: userId,
            userName: userName,
            email: email
        }
        return this.execute('put', '/' + userId, userModel)
    },
    updateIdentityPhone(userId, userName, phone) {
        let userModel = {
            userId: userId,
            userName: userName,
            phoneNumber: phone
        }
        return this.execute('put', '/' + userId, userModel)
    },
    updateIdentityStatus(userId, userName, blockIdentity) {
        let userModel = {
            userId: userId,
            userName: userName,
            status: blockIdentity ? 'BLOCKED' : 'ACTIVE'
        }
        return this.execute('put', '/' + userId, userModel)
    },
    getAllUsers () {
        return this.execute('post', `/query`, {pageSize: 1000})
    },
    getUser (userId) {
        return this.execute('get', `/${userId}`)
    },
    getAllUserDevices (userId) {
        return this.execute('get', `/${userId}/devices` )
    }
}
